/* ── Surgical subtotal update ──
   Instead of innerHTML-swapping #AjaxCartSubtotal (which destroys buttons/CTAs
   and causes visible flash), parse the new section HTML and patch only the
   values that actually change. Buttons, taxes text, structure stay untouched. */
function _patchSubtotalValues(newHTML) {
	var st = document.getElementById('AjaxCartSubtotal');
	if (!st) return;
	var tmp = document.createElement('div');
	tmp.innerHTML = newHTML;

	/* ── Price rows inside .cart__details ── */
	var newD = tmp.querySelector('.cart__details');
	var curD = st.querySelector('.cart__details');
	if (newD && curD) {
		/* Total */
		var nT = newD.querySelector('.cart__total strong:last-child');
		var cT = curD.querySelector('.cart__total strong:last-child');
		if (nT && cT) cT.innerHTML = nT.innerHTML;

		/* Subtotal + Discounts (only present when cart-level discounts exist) */
		/* Jump the Line summary row (Justin 10-6): sits right under Subtotal */
		var nJ = newD.querySelector('.cart__jtl-row');
		curD.querySelectorAll('.cart__jtl-row').forEach(function(r){ r.remove(); });
		if (nJ) {
			var cSub = curD.querySelector('.cart__subtotal');
			if (cSub) cSub.insertAdjacentElement('afterend', nJ.cloneNode(true));
		}

		var jtlChanged = (curD.querySelector('.cart__subtotal') || {getAttribute:function(){return null;}}).getAttribute('data-jtl-cents') !==
			(newD.querySelector('.cart__subtotal') || {getAttribute:function(){return null;}}).getAttribute('data-jtl-cents');

		['.cart__subtotal', '.cart__discounts'].forEach(function(sel) {
			var nR = newD.querySelector(sel);
			var cR = curD.querySelector(sel);
			if (nR && cR) {
			cR.innerHTML = nR.innerHTML;
			var dct = nR.getAttribute('data-cart-total');
			if (dct !== null) cR.setAttribute('data-cart-total', dct);
			var djc = nR.getAttribute('data-jtl-cents');
			if (djc !== null) cR.setAttribute('data-jtl-cents', djc);
		}
			else if (nR && !cR) {
				/* Row appeared — insert before .cart-saving-row or .cart__total */
				var anchor = curD.querySelector('.cart-saving-row') || curD.querySelector('.cart__total');
				if (anchor) anchor.insertAdjacentElement('beforebegin', nR.cloneNode(true));
			} else if (!nR && cR) { cR.remove(); }
		});
		/* JTL toggled: the swap just replaced the Subtotal value with a hidden
		   server copy; re-derive it now (savings don't change with JTL) instead
		   of waiting on the patcher / 1s fallback — that wait made Subtotal pop
		   in late on no-savings carts (Justin 10-6) */
		if (jtlChanged && typeof _saving_update === 'function') _saving_update();
	}

	/* ── Free shipping bars (full container swap) ──
	   Replaces the entire bars container so new bars (e.g. blanks bar appearing
	   for the first time) are inserted and removed bars are cleaned up.
	   Only targets .fullpage-cart (cart page); drawer bars live inside
	   #AjaxCartForm and are handled by the innerHTML swap above. */
	var nFC = tmp.querySelector('.sidebar-widget__content.fullpage-cart');
	var cFC = st.querySelector('.sidebar-widget__content.fullpage-cart');
	if (nFC && cFC) {
		cFC.innerHTML = nFC.innerHTML;
	} else if (nFC && !cFC) {
		var nWidget = nFC.closest('.sidebar-widget');
		var anchor = st.querySelector('.cart-consolidated-card');
		if (nWidget && anchor) anchor.insertAdjacentElement('beforebegin', nWidget.cloneNode(true));
	} else if (!nFC && cFC) {
		var cWidget = cFC.closest('.sidebar-widget');
		if (cWidget) cWidget.remove();
	}
	if (typeof reCalculateFreeShippingModule__recall === 'function') reCalculateFreeShippingModule__recall();

	/* ── Rewards: DO NOT swap innerHTML. The reward app populates the block
	   asynchronously; the fresh Liquid HTML has an empty placeholder that
	   flickers before it repopulates. The reward app recomputes on its own
	   when cart totals change, so leaving the current element alone is best. */

	/* ── Gift wrapping ── */
	var nGw = tmp.querySelector('.cart-gift-widget');
	var cGw = st.querySelector('.cart-gift-widget');
	if (nGw && cGw) cGw.innerHTML = nGw.innerHTML;
}

/* ── Cart merge (Owen 2026-10-23: "reload as few elements as possible" / "only refresh the affected card") ──
   The server render stays the source of truth (Liquid prices, tiers, discounts, upsell counts), but instead of
   swapping the cart form's innerHTML, the fresh HTML is merged in place, three-way: each node remembers what the
   server sent last time, and only what the SERVER changed since then is applied. What scripts changed on their
   own (the price patcher's corrected prices, the free-ship bar width, Yottaa's rewritten URLs and data attrs,
   lazy-loader / layout classes) stays put, so untouched cards are left exactly as they are. Focus, typed qtys,
   open size cards and listeners survive, and nothing flashes.
   Lines match by their cart key, then by position (keys change when a line's properties are rewritten), never
   across products. */
/* remember what the server sent (attributes / text) on a subtree, for the next three-way merge */
function _ntRememberServer(n) {
	if (n.nodeType === 1) {
		var base = {};
		Array.from(n.attributes).forEach(function(a){ base[a.name] = a.value; });
		n.__ntSrv = base;
		Array.from(n.childNodes).forEach(_ntRememberServer);
	} else n.__ntSrv = n.nodeValue;
}
/* what a cart update can change in a blank size card (nt-blank-card.js nbgData): its lines' qtys, prices and tier
   data. The rest (title, thumb, url) only changes through the card itself, and the CDN rewrites the thumb URL in
   the page's copy, so it's left out of the comparison. */
function _ntCardData(g) {
	var el = g.querySelector('script[data-nbg2]');
	if (!el) return '';
	try { var d = JSON.parse(el.textContent); return JSON.stringify([d.lines, d.sizes]); } catch (e) { return el.textContent; }
}
/* a blank size card's prices follow the WHOLE cart's tier (nt-blank-card.js getTierLevel, exposed as
   __ntBlankTierLevel; it may load after this), so a transfers change that crosses a tier line must redraw it too.
   Without that function, any change of the cart total counts. */
function _ntCartTotal(root) {
	var el = root.querySelector('.cart__total[data-cart-total]');
	var dollars = el ? parseFloat(el.textContent.replace(/[^0-9.]/g, '')) : NaN;
	return isNaN(dollars) ? null : dollars;
}
function _ntSameTier(a, b) {
	if (a === b) return true;
	if (a == null || b == null) return false;
	return typeof window.__ntBlankTierLevel === 'function' && window.__ntBlankTierLevel(a) === window.__ntBlankTierLevel(b);
}
function morphCart(fromEl, toEl) {
	var OWNED = '.nbg2-card, .nt-qty-update';   /* injected by scripts; never in the server HTML */
	var FIXED = /^(SCRIPT|LINK|STYLE)$/;          /* never re-applied: re-setting src/href re-fetches */
	var DATA = function(n){ return n.tagName === 'SCRIPT' && /json/i.test(n.getAttribute('type') || ''); };   /* data, not code: kept current (the size card renders from script[data-nbg2]) */
	var owned = function(n){ return n.nodeType === 1 && n.matches(OWNED); };
	var same = function(a, b){
		if (a.nodeType !== b.nodeType) return false;
		if (a.nodeType !== 1) return true;
		return a.tagName === b.tagName && a.getAttribute('data-product-id') === b.getAttribute('data-product-id') &&
			a.hasAttribute('data-id') === b.hasAttribute('data-id') &&
			/* a blank card (product + color) only ever matches the same card: removing one let its wrapper morph into
			   the next plain div (the Clear cart row), carrying its script-drawn size card along (Justin 10-27) */
			a.getAttribute('data-group-key') === b.getAttribute('data-group-key');
	};
	var editing = function(el){
		if (el === document.activeElement) return true;
		var item = el.closest && el.closest('[data-js-cart-item]');
		if (!item || !el.matches('.qty')) return false;
		if (item.__ntWant != null) return true;   /* +/- clicked again while a save was out: its own save is coming */
		var upd = item.querySelector('.nt-qty-update');
		return !!(upd && !upd.hidden);
	};
	var syncAttrs = function(from, to){
		/* a cart line handed another line's key: what scripts stored on it (the patcher's data-server-qty for merged
		   rows) described the old line — drop it; the patcher re-adds it. Same key: it still holds. */
		if (to.hasAttribute('data-js-cart-item') && from.getAttribute('data-id') !== to.getAttribute('data-id')) {
			Array.from(from.attributes).forEach(function(a){
				if (/^data-/.test(a.name) && a.name !== 'data-href' && !to.hasAttribute(a.name)) from.removeAttribute(a.name);
			});
		}
		var base = from.__ntSrv;
		var names = {};
		Array.from(to.attributes).forEach(function(a){ names[a.name] = 1; });
		if (base) Object.keys(base).forEach(function(k){ names[k] = 1; });
		else Array.from(from.attributes).forEach(function(a){ names[a.name] = 1; });
		Object.keys(names).forEach(function(name){
			var tv = to.getAttribute(name);
			if (base && base[name] === (tv == null ? undefined : tv)) return;   /* server unchanged: leave the client's value */
			if (!base && (name === 'style' || name === 'data-href') && tv == null) return;   /* first merge: keep script-set styles / stash */
			if (name === 'href' && from.hasAttribute('data-href')) return;   /* ajaxify blanked it on purpose */
			if ((name === 'src' || name === 'srcset') && tv != null && String(from.getAttribute(name) || '').split('?')[0].replace(/^https?:/, '') === tv.split('?')[0].replace(/^https?:/, '')) return;   /* the CDN rewrote only the query */
			if (tv == null) { from.removeAttribute(name); return; }
			if (name === 'class') {
				var keep = Array.from(from.classList).filter(function(c){ return /^w3_/.test(c); });
				if (keep.length) tv = (tv + ' ' + keep.join(' ')).trim();
			}
			if (from.getAttribute(name) !== tv) from.setAttribute(name, tv);
		});
	};
	var syncValue = function(from, to){
		/* a textarea's text is its child text node (no value attribute): the child morph updates it, and its value
		   follows unless someone typed in it (the cart note editor; the note view is trimmed from its value) */
		if (!/^(INPUT|SELECT)$/.test(from.tagName) || editing(from)) return;
		if (from.type === 'checkbox' || from.type === 'radio') from.checked = to.hasAttribute('checked');
		else if (from.tagName === 'SELECT') from.value = to.value;
		else {
			var v = to.getAttribute('value'); v = v == null ? '' : v;
			var b = from.__ntSrv && from.__ntSrv.value;
			/* server unchanged: keep what a script wrote — but a line's qty box not being edited shows the cart's qty
			   (a save the cart refused leaves the server's value as it was) */
			var li = from.matches('.qty') && from.closest('[data-js-cart-item]');
			var cartQty = li && !li.hasAttribute('data-server-qty');   /* a merged ghost row shows the patcher's sum */
			if (b !== undefined && b === v && !cartQty) return;
			if (from.value !== v) from.value = v;
		}
	};
	var morphNode = function(from, to){
		if (from.nodeType !== 1) {
			if (from.__ntSrv !== undefined && from.__ntSrv === to.nodeValue) return;
			if (from.nodeValue !== to.nodeValue) from.nodeValue = to.nodeValue;
			from.__ntSrv = to.nodeValue;
			return;
		}
		if (FIXED.test(from.tagName) && !DATA(from)) return;
		syncValue(from, to);
		syncAttrs(from, to);
		/* a component that draws its own content (nt-geo-tiers free-ship card, nt-geo-fact — assets/nt-geo-ui.js):
		   the server sends it empty, so keep what it drew and let it redraw from its updated attributes */
		if (typeof from.__ntRender === 'function') {
			var base0 = {};
			Array.from(to.attributes).forEach(function(a){ base0[a.name] = a.value; });
			from.__ntSrv = base0;
			try { from.__ntRender(); } catch (e) {}
			return;
		}
		morphChildren(from, to);
		var base = {};
		Array.from(to.attributes).forEach(function(a){ base[a.name] = a.value; });
		from.__ntSrv = base;
	};
	var morphChildren = function(from, to){
		/* lines match by their cart key first (a card wrapper by the first line it holds);
		   position (same product) only when a key changed */
		var keyOf = function(c){
			if (c.nodeType !== 1 || owned(c)) return '';
			var k = c.getAttribute('data-id'); if (k) return k;
			var line = c.querySelector('[data-js-cart-item][data-id]');
			return line ? 'w:' + c.tagName + '.' + (c.classList[0] || '') + ':' + line.getAttribute('data-id') : '';
		};
		var keyed = {}, dup = {};
		Array.from(from.children).forEach(function(c){ var k = keyOf(c); if (!k) return; if (keyed[k]) dup[k] = 1; keyed[k] = c; });
		var toKeys = {}, seen = {};
		Array.from(to.children).forEach(function(c){ var k = keyOf(c); if (!k) return; if (seen[k]) dup[k] = 1; seen[k] = 1; if (keyed[k]) toKeys[k] = 1; });
		Object.keys(dup).forEach(function(k){ delete toKeys[k]; });   /* ambiguous: leave to position */
		var reserved = function(n){ return n && n.nodeType === 1 && toKeys[keyOf(n)]; };
		var cur = from.firstChild;
		var skip = function(){ while (cur && (owned(cur) || reserved(cur))) cur = cur.nextSibling; };
		Array.from(to.childNodes).forEach(function(t){
			var k = keyOf(t);
			if (k && toKeys[k]) {
				var km = keyed[k]; delete toKeys[k];
				if (km === cur) cur = cur.nextSibling;
				from.insertBefore(km, cur);
				morphNode(km, t);
				return;
			}
			skip();
			if (cur && !same(cur, t)) {
				/* a line went away: drop it when the next one is the match */
				var nx = cur.nextSibling; while (nx && (owned(nx) || reserved(nx))) nx = nx.nextSibling;
				if (nx && same(nx, t)) { var dead = cur; cur = nx; dead.remove(); }
			}
			if (cur && same(cur, t)) { var m = cur; cur = cur.nextSibling; morphNode(m, t); }
			else { _ntRememberServer(t); from.insertBefore(t, cur); }
		});
		while (cur) { var n = cur.nextSibling; if (!owned(cur)) cur.remove(); cur = n; }
	};
	morphChildren(fromEl, toEl);
}

/* ── Instant +/- line total (Owen 2026-10-23: "make the updates quicker") ──
   The save itself takes ~1s on Shopify's side, so a +/- shows the line's new total right away, but only when
   it can't be wrong: the line carries its break band (snippets/arrange-properties.liquid .nt-tier-band) and its
   group's pieces, counting every unsaved change in the group, stay inside it, so price each holds and the total
   is price each x qty (the cart's per-piece rounding included). Across a break every line in the group reprices,
   so those wait for the server, as do the cart totals. The save's merge then writes the server's numbers. */
/* the qty the cart has for a line: data-qty (the patcher's sum on a merged duplicate row), or, on rows that don't
   carry it (Names & Numbers entries), the qty box's server value attribute */
function _ntCartQty(item) {
	if (!item) return NaN;
	if (item.hasAttribute('data-qty')) return parseInt(item.getAttribute('data-qty'), 10);
	var q = item.querySelector('.qty');
	return q ? parseInt(q.getAttribute('value'), 10) : NaN;
}
function _ntMoney(c) {
	var s = (c / 100).toFixed(2).split('.');
	return '$' + s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + s[1];
}
function _ntSetText(el, t) {
	var n = el.firstChild;
	if (n && n.nodeType === 3 && !n.nextSibling) { if (n.nodeValue !== t) n.nodeValue = t; }   /* keeps the merge's baseline */
	else el.textContent = t;
}
function _ntOptimistic(item, qty) {
	var band = item && item.querySelector('.nt-tier-band');
	var was = _ntCartQty(item);
	if (!band || !(qty > 0) || !(was > 0)) return;
	var sq = item.getAttribute('data-server-qty');
	if (sq && sq !== item.dataset.qty) return;   /* a merged ghost row: its total spans two lines */
	var g = band.getAttribute('data-g'), n = parseInt(band.getAttribute('data-q'));
	(item.closest('cart-form') || document).querySelectorAll('[data-js-cart-item]').forEach(function(l){
		var b = l.querySelector('.nt-tier-band');
		if (!b || b.getAttribute('data-g') !== g) return;
		var v = l === item ? qty : parseInt((l.querySelector('.qty') || {}).value), d = _ntCartQty(l);
		if (!isNaN(v) && !isNaN(d)) n += v - d;
	});
	var lo = parseInt(band.getAttribute('data-lo')) || 0, hi = parseInt(band.getAttribute('data-hi')) || 0;
	if (isNaN(n) || n < lo || (hi && n >= hi)) return;
	var opt = window.__ntOptEls = window.__ntOptEls || new Set();
	var show = function(el, t){ _ntSetText(el, t); el.__ntOptLine = item; opt.add(el); };
	var root = item.querySelector('strong[data-line-item-cost]') ? item : (item.closest('.nt-design-group') || item);
	var ea = root.querySelector('.discounted-line-item-price del strong') || root.querySelector('.discounted-line-item-price del');
	var retailEach = ea ? Math.round(parseFloat(ea.textContent.replace(/[^0-9.]/g, '')) * 100) : 0;
	root.querySelectorAll('strong[data-line-item-cost]').forEach(function(s){
		var cost = parseInt(s.getAttribute('data-line-item-cost'));   /* the server's line total, for the server's qty */
		if (!(cost > 0) || cost % was) return;
		show(s, _ntMoney(cost / was * qty));
		var r = s.parentNode && s.parentNode.classList.contains('line-total-wrap') && s.parentNode.querySelector('.line-total-retail');
		if (r && retailEach > 0) show(r, _ntMoney(retailEach * qty));
	});
	/* "Add N to save X%" on every line of the group counts down with it */
	if (hi) (item.closest('cart-form') || document).querySelectorAll('[data-js-cart-item]').forEach(function(l){
		var b = l.querySelector('.nt-tier-band');
		if (b && b.getAttribute('data-g') === g) l.querySelectorAll('._upsell_cta ._qty_val').forEach(function(v){ show(v, String(hi - n)); });
	});
}
/* after a save's merge: numbers shown ahead of a save that's done go back to what the server sent (a merge leaves
   them alone when the server's value didn't change — a refused qty, say); lines still waiting on a save show theirs again */
function _ntSettleOptimistic(form) {
	var opt = window.__ntOptEls;
	if (opt) opt.forEach(function(el){
		var line = el.__ntOptLine;
		if (line && line.isConnected && line.__ntWant != null) return;
		opt.delete(el);
		if (!el.isConnected) return;
		var cost = el.matches('strong[data-line-item-cost]') && parseInt(el.getAttribute('data-line-item-cost'));
		var n = el.firstChild;
		if (cost > 0) _ntSetText(el, _ntMoney(cost));
		else if (n && n.nodeType === 3 && typeof n.__ntSrv === 'string') _ntSetText(el, n.__ntSrv);
	});
	form.querySelectorAll('[data-js-cart-item]').forEach(function(l){ if (l.__ntWant != null) _ntOptimistic(l, l.__ntWant); });
}

/* ── One cart read at a time (Owen 2026-10-23) ──
   After a cart change a dozen scripts read the cart at once (cart count, pre-cut sync, price patcher, upsells,
   apps) and two sections get fetched twice. Identical GETs of /cart, /cart.js, /cart.json (incl. ?sections=)
   that are already on the way share that one response; each caller gets its own copy. Only requests in flight
   are shared (an app can change the cart in ways this page never sees, e.g. the Storefront API), and any cart
   write through fetch or XHR ends sharing at once. */
if ( !window.__ntCartReadShare && window.fetch ) {
	window.__ntCartReadShare = true;
	(function(){
		var nativeFetch = window.fetch, live = {};
		var path = function(u){ return u.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/cart)/i, ''); };
		var parse = function(u){ try { return new URL(u, location.href); } catch (e) { return null; } };
		window.fetch = function(input, init){
			var u = parse(typeof input === 'string' ? input : (input && input.url) || String(input || ''));
			var method = String((init && init.method) || (input && typeof input === 'object' && input.method) || 'GET').toUpperCase();
			if (!u || u.origin !== location.origin) return nativeFetch.apply(this, arguments);
			var p = path(u);
			if (method !== 'GET') {
				if (/^\/cart\//.test(p)) live = {};
				return nativeFetch.apply(this, arguments);
			}
			if (!/^\/cart(\.js|\.json)?$/.test(p) || typeof input !== 'string' || (init && (init.signal || init.keepalive || init.body))) return nativeFetch.apply(this, arguments);
			var k = p + u.search + '|' + JSON.stringify((init && init.headers) || null) + '|' + ((init && init.cache) || '');
			var hit = live[k];
			if (!hit) {
				hit = live[k] = nativeFetch.apply(this, arguments);
				var end = function(){ if (live[k] === hit) delete live[k]; };
				hit.then(function(r){ return r.clone().arrayBuffer(); }).then(end, end);   /* shared until the body is in */
			}
			return hit.then(function(r){ return r.clone(); });
		};
		var xOpen = XMLHttpRequest.prototype.open;
		XMLHttpRequest.prototype.open = function(m, url){
			var u = parse(String(url || ''));
			if (u && u.origin === location.origin && String(m).toUpperCase() !== 'GET' && /^\/cart\//.test(path(u))) live = {};
			return xOpen.apply(this, arguments);
		};
	})();
}

if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {
		constructor(){
			super();
			/* the page-load render is the first server baseline for morphCart (before scripts start editing it) */
			const remember = () => {
				Array.from(this.childNodes).forEach(_ntRememberServer);
				this.__ntGroupSig = {};
				this.__ntTotal = _ntCartTotal(this);
				this.querySelectorAll('.nt-blank-group.nbg2').forEach(g => { this.__ntGroupSig[g.getAttribute('data-group-key')] = _ntCardData(g); });
			};
			if ( this.firstElementChild ) remember();
			else document.addEventListener('DOMContentLoaded', remember, { once: true });
			this.ajaxifyCartItems();
			// Delegated remove-click handler — survives DOM mutations from any source
			// (cart section re-renders, app scripts, patcher writes, etc.)
			this.addEventListener('click', (e) => {
				const removeEl = e.target.closest('.remove');
				if (!removeEl) return;
				if (!this.contains(removeEl)) return;
				// Skip JTL/Pre-cut branch (uses inline onclick for precut-confirm flow)
				if (removeEl.getAttribute('href') === 'javascript:void(0)') return;
				const item = removeEl.closest('[data-js-cart-item]');
				if (!item) return;
				e.preventDefault();
				e.stopImmediatePropagation();
				this.updateCartQty(item, 0);
			}, true); // capture phase so we beat any app-injected listeners
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				/* runs after every render AND every merge: wire each element once (a merge keeps elements) */
				const once = (el, k) => { if (!el || el['__nt' + k]) return false; el['__nt' + k] = true; return true; };

				const remove = item.querySelector('.remove');
				if ( remove && remove.getAttribute('href') ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
				}
				if ( once(remove, 'Rm') ) {
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				const updOld = qty && (qty.closest('product-quantity') || qty.parentElement).querySelector('.nt-qty-update');
				/* Update is for a typed qty only: a line with its save on the way (+/-, or a committed typed qty) has none */
				if ( updOld ) { const v = parseInt(qty.value, 10); const h = isNaN(v) || v === _ntCartQty(item) || item.__ntWant != null; if ( updOld.hidden !== h ) updOld.hidden = h; }
				if ( once(qty, 'Qty') ) {
					/* Typing no longer commits on a timer (Owen 2026-10-23): an Update button shows while the typed
					   qty differs from the cart, and typed qtys commit on Update, Enter, or clicking out. Clicking
					   from one qty box into another commits nothing (no refresh between boxes); every typed qty
					   commits together when focus leaves the boxes. The +/- steppers keep their own 300ms commit
					   (CartProductQuantity). */
					const holder = qty.closest('product-quantity') || qty.parentElement;
					const upd = document.createElement('button');
					upd.type = 'button';
					upd.className = 'nt-qty-update';
					upd.textContent = 'Update';
					upd.hidden = true;
					holder.appendChild(upd);   /* sits under the stepper (CSS): inserting it into the row reflowed the line layouts */
					const synced = () => _ntCartQty(item);
					qty.addEventListener('input', (e)=>{
						if ( !e.isTrusted ) return;   /* the +/- steppers' own events: they save themselves */
						const v = parseInt(qty.value, 10);
						upd.hidden = isNaN(v) || v === synced();
						if ( !upd.hidden ) item.__ntWant = null;   /* typing takes over from a +/- still waiting */
					});
					qty.addEventListener('focusout', (e)=>{
						const v = parseInt(qty.value, 10);
						if ( isNaN(v) || v < 0 ) { qty.value = synced(); upd.hidden = true; return; }
						const to = e.relatedTarget;
						if ( to && to.matches && to.matches('.qty') && this.contains(to) ) return;   /* box to box: stay pending */
						this.commitPending();
					});
					qty.addEventListener('keydown', (e)=>{
						if ( e.key === 'Enter' ) { e.preventDefault(); this.commitPending(); }
					});
					/* keep focus in the field on press, so the focusout commit can't race the click */
					upd.addEventListener('mousedown', (e)=>{ e.preventDefault(); });
					upd.addEventListener('click', (e)=>{ e.preventDefault(); this.commitPending(); });
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

				/* SOLO layout: [data-js-cart-item] is .nt-dg-solo-controls, which has
				   only qty buttons. The ._upsell_cta button + .propitems live in the
				   sibling .nt-dg-info (both inside .nt-dg-header). Fall back to the
				   enclosing header for both lookup and update scope. */
				const upsell = item.querySelector('._upsell_cta')
					|| item.closest('.nt-dg-header')?.querySelector('._upsell_cta');
				if ( once(upsell, 'Up') ) {
					upsell.addEventListener('click', (e)=>{
						var pNode = e.target.closest('._upsell_parent_block')
							|| upsell.closest('.nt-design-group');
						var qtyNode = pNode.querySelector('._discount-list');
						var qty_value = qtyNode.dataset.min;
						var scope = item;
						if (!item.querySelector('.propitems')) {
							var header = item.closest('.nt-dg-header');
							if (header) {
								if (!header.dataset.id) header.dataset.id = item.dataset.id;
								scope = header;
							}
						}
						this.updateUpsell(scope, parseInt(qty_value));
					})
				}
			})
            if (typeof _upsell_check === 'function') {
              _upsell_check();
            }
		}


		updateUpsell(item, newQty){
			let alert = null;
			let upsellSucceeded = false;
			/* only this line waits on the save (see updateCartQty) */
			item.classList.add('nt-line-busy');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			var propitems = item.querySelector(".propitems")
			var order_properties =  $.trim($(propitems).val());
			var _json_prop = {};
			if(order_properties != ""){
				_json_prop = JSON.parse(order_properties);
				$.each(_json_prop, function(key, value) {
					if(key == "_discount_name"){
						_json_prop[key] = decodeURIComponent(value);
					}
					if(key == "_discount_input"){
						_json_prop[key] = decodeURIComponent(value);
					}
					if(value.indexOf("https%3A%2F%2F") > -1){
						_json_prop[key] = decodeURIComponent(value);
					}
				});
			}
			const body = JSON.stringify({
				id: item.dataset.id,
				quantity: newQty,
				properties : _json_prop,
				sections: 'helper-cart',
				sections_url: window.location.pathname
			});

			fetch(KROWN.settings.routes.cart_change_url, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
				body
				})
				.then(response => response.text().then(text => {
					try { return JSON.parse(text); } catch (e) { return { status: response.status }; }
				}))
				.then(response => {
					if ( response.status == 422 ) {
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					/* Use inline section from /cart/change response when available; fallback to
					   legacy GET only if the response didn't include sections. */
					if (response && response.sections && typeof response.sections['helper-cart'] === 'string') {
						return response.sections['helper-cart'];
					}
					return fetch('?section_id=helper-cart').then(r => r.text());
				})
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const sectionCartForm = sectionInnerHTML.getElementById('AjaxCartForm');
					const sectionSubtotal = sectionInnerHTML.getElementById('AjaxCartSubtotal');
					if ( !sectionCartForm || !sectionSubtotal ) { return; }
					upsellSucceeded = true;
					const cartSubtotalInnerHTML = sectionSubtotal.innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					window.__ntCartCache = null;
					cartItems.mergeFrom(sectionCartForm);

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						let _cartno = cartItems.querySelector('[data-cart-count]')?.textContent || '0';
						elm.textContent = _cartno;
						elm.setAttribute("data-count",_cartno);
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]')?.textContent || '';
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					}

					_patchSubtotalValues(cartSubtotalInnerHTML);

					const event = new Event('cart-updated', { bubbles: true });
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log('updateCart error:', e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
					item.classList.remove('nt-line-busy');
					/* Hold the dim until the patcher corrects tier prices — see updateCartQty comment */
					if (!upsellSucceeded) {
						this.classList.remove('cart-refreshing');
						_saving_update();
					}
                    if (typeof _upsell_check === 'function') {
                      _upsell_check();
					}
				});
      }


			/* ── Pending (uncommitted) qty edits ──
			   Qty edits wait for a commit (typing → Update / Enter / blur; +/- → 300ms timer) with no
			   other commit path, so leaving before the timer fires would discard the change.
			   A row is "pending" when its live input value differs from data-qty — the patcher
			   keeps .value and data-qty in sync at rest, so a divergence means the user changed
			   the qty after the last render. Shared by the pagehide backstop and the
			   commit-before-checkout handler below. updateCartQty does the merged-row delta
			   translation, so committing via it stays correct for ghost-merged lines. */
			pendingRows(){
				var out = [];
				this.querySelectorAll('[data-js-cart-item]').forEach(function(item){
					var input = item.querySelector('.qty-selector, input[name="updates[]"], .qty');
					if (!input) return;
					var cur = parseInt(input.value), synced = _ntCartQty(item);
					if (!isNaN(cur) && !isNaN(synced) && cur !== synced) out.push({ item: item, qty: cur });
				});
				return out;
			}

			/* Commit every typed, uncommitted qty (Update / Enter / clicking out of the qty boxes). One line at a
			   time: each update re-renders the form AND can change line keys (line properties get rewritten), so
			   each later line is found again by its position, bottom-up so a qty-0 removal can't shift the rest. */
			commitPending(){
				if ( this._ntCommitting ) return this._ntCommitting;
				const all = [...this.querySelectorAll('[data-js-cart-item]')];
				const pend = this.pendingRows().map(p => ({ idx: all.indexOf(p.item), qty: p.qty, item: p.item })).sort((a, b) => b.idx - a.idx);
				if ( !pend.length ) return Promise.resolve();
				pend.forEach(p => { p.item.__ntWant = p.qty; _ntOptimistic(p.item, p.qty); });
				const run = pend.reduce((chain, p) => chain.then(() => {
					const item = this.querySelectorAll('[data-js-cart-item]')[p.idx] || p.item;
					return this.updateCartQty(item, p.qty);
				}), Promise.resolve());
				this._ntCommitting = run.catch(()=>{}).finally(() => { this._ntCommitting = null; });
				return this._ntCommitting;
			}

			/* Best-effort commit for page-exit paths where keepalive survives (same-origin
			   nav, tab close). The checkout button is handled separately by commit-before-nav
			   below, because the cross-origin checkout redirect drops keepalive requests. */
			flushPendingQty(useKeepalive){
				var self = this;
				this.pendingRows().forEach(function(p){
					self.updateCartQty(p.item, p.qty, { keepalive: useKeepalive === true });
				});
			}

			/* Merge a freshly rendered cart form into this one (morphCart) and wire up only what's new. The blanks
			   price patcher and the size cards re-run on added nodes, and a merge mostly edits text in place, so
			   nudge their observers once. */
			mergeFrom(sectionCartForm){
				/* a blank size card redraws (nt-blank-card drops in on groups without nbg2-on) only when its own
				   server render changed — not on every cart change */
				/* compared by the card's own data + the cart's tier (server render to server render) */
				const prevSig = this.__ntGroupSig || {};
				const nextSig = {};
				const changed = new Set();
				const nextTotal = _ntCartTotal(sectionCartForm);
				const tierMoved = !_ntSameTier(this.__ntTotal, nextTotal);
				sectionCartForm.querySelectorAll('.nt-blank-group.nbg2').forEach(g => {
					const k = g.getAttribute('data-group-key');
					nextSig[k] = _ntCardData(g);
					if (tierMoved || prevSig[k] !== nextSig[k]) changed.add(k);
				});
				this.__ntGroupSig = nextSig;
				this.__ntTotal = nextTotal;
				morphCart(this, sectionCartForm);
				this.querySelectorAll('.nt-blank-group.nbg2.nbg2-on').forEach(g => {
					if (changed.has(g.getAttribute('data-group-key'))) g.classList.remove('nbg2-on');
				});
				this.ajaxifyCartItems();
				const nudge = document.createComment('nt-cart-merged');
				this.appendChild(nudge);
				nudge.remove();
			}

			/* One update at a time: each response carries the whole cart state, so overlapping responses could
			   land out of order. Page-exit flushes (keepalive) go out immediately. */
			updateCartQty(item, newQty, flushOpts = {}){
				if ( flushOpts.keepalive ) return this._updateCartQtyNow(item, newQty, flushOpts);
				const run = () => this._updateCartQtyNow(item, newQty, flushOpts);
				this._ntQueue = (this._ntQueue || Promise.resolve()).then(run, run);
				return this._ntQueue;
			}

			_updateCartQtyNow(item, newQty, flushOpts = {}){

				/* a +/- save reads its line and qty when its turn comes (clicks made while it waited ride along),
				   and skips when that's what the cart already has (+ then -) */
				if ( typeof newQty === 'function' ) {
					const want = newQty();
					item = want.item; newQty = want.qty;
					if ( !item || isNaN(newQty) || newQty < 0 || newQty === _ntCartQty(item) ) {
						if ( item && item.__ntWant === newQty ) { item.__ntWant = null; _ntSettleOptimistic(this); }
						return Promise.resolve();
					}
				}

				let alert = null;

				/* nothing waits on a qty save: no whole-form .processing fade or cart-refreshing shimmer, and the
				   line's own controls stay live (a click during the save rides on one more; see changeCartInput) */
				if ( this.querySelector('.alert') ) {
					this.querySelector('.alert').remove();
				}

				/* Merged-row delta translation: the patcher visually merges duplicate
				   Shopify lines (e.g. 51 primary + 5 ghost = 56 displayed). The .qty
				   input shows 56. When user clicks +, newQty is 57. But we must send
				   the delta relative to the PRIMARY's server qty (51+1=52), not the
				   merged display (57). data-server-qty holds the primary's real qty;
				   data-qty holds the displayed merged total. */
				const serverQty = parseInt(item.getAttribute('data-server-qty')) || 0;
				const displayedQty = parseInt(item.getAttribute('data-qty')) || 0;
				/* expectedDisplayQty = what the user expects to see after the update.
				   Saved before delta translation so we can pre-set it on the new DOM
				   immediately after innerHTML swap — avoids a flash of the raw server
				   qty (e.g. 52) before the patcher merges it back to the display total (57). */
				const expectedDisplayQty = newQty;
				if (newQty > 0 && serverQty > 0 && displayedQty > 0 && serverQty !== displayedQty) {
					const delta = newQty - displayedQty;
					newQty = Math.max(0, serverQty + delta);
				}

				/* Single round-trip: ask /cart/change to render the cart section in the same
				   response via Shopify's `sections` param. Saves the follow-up GET /?section_id=.
				   sections_url MUST be the current page path (not hardcoded '/cart') because
				   helper-cart.liquid branches on `template contains 'cart'` to decide between
				   cart-form-page (full page) vs cart-form (sidebar/drawer). Using '/cart' would
				   force page markup into the drawer on non-cart pages. */
				const body = JSON.stringify({
					id: item.dataset.id,
					quantity: newQty,
					sections: 'helper-cart',
					sections_url: window.location.pathname
				});

				/* Retry helper: on 429 (rate limited), wait and retry up to 2 times with backoff.
				   Without this, rapid qty changes silently fail and UI goes out of sync with cart. */
				const fetchWithRetry = (url, opts, retries = 2, delay = 500) => {
					return fetch(url, opts).then(r => {
						if (r.status === 429 && retries > 0) {
							return new Promise(res => setTimeout(res, delay))
								.then(() => fetchWithRetry(url, opts, retries - 1, delay * 2));
						}
						return r;
					});
				};

				/* Remember pre-click qty so we can revert the input if the update fails entirely */
				const prevQty = isNaN(_ntCartQty(item)) ? '' : String(_ntCartQty(item));
				const qtyInput = item.querySelector('.qty-selector, input[name="updates[]"]');
				let updateSucceeded = false;

				return fetchWithRetry(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body,
					/* keepalive lets a page-exit flush (pagehide / checkout click) finish even as
					   the navigation tears this page down — without it the browser cancels the
					   in-flight POST and the qty change is lost. No effect on normal in-page
					   updates (flushOpts.keepalive is undefined → false on those calls). */
					keepalive: flushOpts.keepalive === true
				})
				.then(response => response.text().then(text => {
					/* Tolerate HTML response (some Shopify configs return HTML from /cart/change
					   even with Accept: application/javascript). Parse as JSON if possible,
					   otherwise return a stub — the section refetch is the source of truth. */
					const parsed = (() => { try { return JSON.parse(text); } catch (e) { return null; } })();
					return parsed || { status: response.status };
				}))
				.then(response => {
					if ( response.status == 422 ) {
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					/* Prefer the inline section returned by /cart/change. Fallback to the legacy
					   GET /?section_id= only if the change response didn't include sections (older
					   Shopify configs, or if request was rejected with no JSON body). */
					if (response && response.sections && typeof response.sections['helper-cart'] === 'string') {
						return response.sections['helper-cart'];
					}
					return fetchWithRetry('?section_id=helper-cart', {}).then(r => r.text());
				})
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const sectionCartForm = sectionInnerHTML.getElementById('AjaxCartForm');
					const sectionSubtotal = sectionInnerHTML.getElementById('AjaxCartSubtotal');
					/* Section fetch failed (429 after retries, auth redirect, etc.) — revert input
					   so it stays in sync with server state instead of showing the clicked-but-not-saved value. */
					if ( !sectionCartForm || !sectionSubtotal ) {
						item.__ntWant = null;
						if (qtyInput && prevQty) qtyInput.value = prevQty;
						_ntSettleOptimistic(this);
						return;
					}
					updateSucceeded = true;
					const cartSubtotalInnerHTML = sectionSubtotal.innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					window.__ntCartCache = null;
					if ( item.__ntWant === expectedDisplayQty ) item.__ntWant = null;   /* this save was the last word */
					cartItems.mergeFrom(sectionCartForm);
					_ntSettleOptimistic(cartItems);

					/* Pre-set the expected merged qty on the primary row so the user
					   doesn't see the raw server qty (e.g. 52) flash before the patcher
					   merges it to the display total (e.g. 57). */
					if (expectedDisplayQty > 0 && serverQty > 0 && serverQty !== displayedQty) {
						var newPrimaryRow = cartItems.querySelector('[data-id="' + item.dataset.id + '"]');
						if (newPrimaryRow) {
							newPrimaryRow.querySelectorAll('.qty').forEach(function(inp) { inp.value = expectedDisplayQty; });
							newPrimaryRow.setAttribute('data-qty', String(expectedDisplayQty));
						}
					}

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						let _cartno = cartItems.querySelector('[data-cart-count]')?.textContent || '0';
						elm.textContent = _cartno;
						elm.setAttribute("data-count",_cartno);
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]')?.textContent || '';
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					}

					_patchSubtotalValues(cartSubtotalInnerHTML);
					if ( typeof reCalculateFreeShippingModule === 'function' ) {
						reCalculateFreeShippingModule();
					}
					const event = new Event('cart-updated', { bubbles: true });
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log('updateCartQty error:', e);
					/* Revert input to last-known server qty so UI stays in sync */
					item.__ntWant = null;
					if (qtyInput && prevQty) qtyInput.value = prevQty;
					_ntSettleOptimistic(this);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
					/* On success, do NOT remove cart-refreshing here — the blanks-price-patcher
					   will remove it after it has written the corrected tier prices into the DOM.
					   Lifting the dim before the patcher runs causes a visible flash of Shopify's
					   raw Liquid prices (compare_at_price etc.) that get overwritten a moment later.
					   On failure (updateSucceeded = false), the patcher won't run, so we un-dim now. */
					if (!updateSucceeded) {
						this.classList.remove('cart-refreshing');
						_saving_update();
					}
					/* On success, _saving_update is called by the patcher AFTER it
					   writes the correct tier savings into #moneySaved. Calling it
					   here would flash the stale Liquid-rendered value first. */
                    if (typeof _upsell_check === 'function') {
                      _upsell_check();
					}
				});
			}

		}


		if ( typeof customElements.get('cart-form') == 'undefined' ) {
			customElements.define('cart-form', CartForm);
		}

		/* ── Persist pending qty edits on page exit ──
		   Uncommitted qty edits (typed, Update not pressed / +/- inside its 300ms) have no other commit path,
		   so leaving before the timer fires would drop the change. Two exit handlers, bound once. */
		if ( !window.__ntCartFlushBound ) {
			window.__ntCartFlushBound = true;

			/* (1) Non-checkout exits (in-site link, browser Back, tab close): keepalive flush.
			   Survives same-origin teardown; a no-op when nothing is pending. */
			window.addEventListener('pagehide', function(){
				document.querySelectorAll('cart-form').forEach(function(cf){
					if (typeof cf.flushPendingQty === 'function') cf.flushPendingQty(true);
				});
			});

			/* (2) Checkout: keepalive does NOT survive the cross-origin checkout redirect
			   (→ shop.app / Shopify checkout), so instead of relying on unload we COMMIT the
			   pending qty and await it, THEN let the navigation proceed. Only intervenes when
			   there's an unsaved edit — normal checkout is untouched. A 2s safety timer
			   guarantees the customer is never trapped on the cart if the commit stalls. */
			document.addEventListener('click', function(e){
				var trigger = e.target && e.target.closest && e.target.closest('#CheckOut, #MobileStickyCheckout, #MobileStickyCompactBtn');
				if (!trigger) return;
				var cf = document.querySelector('cart-form');
				if (!cf || typeof cf.pendingRows !== 'function') return;
				var pending = cf.pendingRows();
				if (!pending.length) return;                       // nothing unsaved → normal checkout
				e.preventDefault();
				e.stopImmediatePropagation();
				var dest = trigger.getAttribute('href') || '/checkout';
				var went = false;
				var go = function(){ if (went) return; went = true; window.location.href = dest; };
				setTimeout(go, 2000);                              // safety net — never trap the customer
				Promise.all(pending.map(function(p){ return cf.updateCartQty(p.item, p.qty); })).then(go, go);
			}, true);

			/* (3) Back/forward INTO the cart: covers BOTH bfcache restore (persisted) AND a
			   back/forward *reload* (persisted=false but navType 'back_forward') — the reload
			   serves stale cached cart HTML without reconciling the qty input to the server, so
			   a qty saved right before leaving (e.g. before checkout) paints stale. refreshCart
			   re-renders the section from the server, re-syncing the inputs. Fresh loads skip. */
			window.addEventListener('pageshow', function(e){
				var navType = (performance.getEntriesByType('navigation')[0] || {}).type;
				if (!e.persisted && navType !== 'back_forward') return;  // bfcache OR back/fwd reload only
				if (!document.querySelector('cart-form')) return;  // only cart surfaces
				if (typeof window.refreshCart === 'function') window.refreshCart('notOpen');
				else window.location.reload();
			});
		}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			/* Debounce rapid +/- clicks so large carts don't queue multiple section fetches.
			   Each click resets the timer; only the final value fires /cart/change. The line's total shows the
			   new qty right away (_ntOptimistic); a save already waiting its turn sends the latest value, so
			   clicks during a save add at most one more. */
			var self = this;
			var qtyNow = function(){ return parseInt(self.querySelector('.qty').value); };
			setTimeout(function(){   /* after the stepper has written the new value */
				var item = self.closest('[data-js-cart-item]'), q = qtyNow();
				if ( !item || isNaN(q) ) return;
				item.__ntWant = q;
				_ntOptimistic(item, q);
			}, 0);
			if ( this._changeTimer ) clearTimeout(this._changeTimer);
			this._changeTimer = setTimeout(function(){
				self._changeTimer = null;
				if ( self._ntQueued ) return;
				self._ntQueued = true;
				document.getElementById('AjaxCartForm').updateCartQty(null, function(){
					self._ntQueued = false;
					return { item: self.closest('[data-js-cart-item]'), qty: qtyNow() };
				});
			}, 150);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = ( cartAct, addData, sectionText ) => {

		/* Silent mode ('notOpen'): called by background reconciliation flows
		   (precut sync in precut-func.liquid → handleCartAction → refreshCart('notOpen')).
		   The first shimmer (from updateCartQty) already covered the visible cart update;
		   firing a second shimmer here produces the "two load states" the user sees
		   after every qty change when precut reconciliation runs. Skip the shimmer
		   in silent mode — the brief DOM replacement is imperceptible and the patcher
		   still corrects tier prices immediately after. */
		var isSilent = (cartAct === 'notOpen');
		var cartEl = document.getElementById('AjaxCartForm');
		if (cartEl && !isSilent) cartEl.classList.add('cart-refreshing');
		var refreshSucceeded = false;

		/* cache:'no-store' — on a back/forward navigation the section response is otherwise
		   served stale from the bf/HTTP cache, so a refresh after Back would re-render the OLD
		   qty. Forcing a network fetch keeps the re-sync correct. */
		/* sectionText (Owen 2026-10-05): when the caller already received the
		   rendered section inside its /cart/add|change response (Shopify's
		   `sections` request param), skip this follow-up GET — one round trip
		   instead of two. Absent/empty falls through to the fetch as before. */
		( sectionText
			? Promise.resolve(sectionText)
			: fetch('?section_id=helper-cart', { cache: 'no-store' }).then(response => response.text())
		)
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const sectionCartForm = sectionInnerHTML.getElementById('AjaxCartForm');
			const sectionSubtotal = sectionInnerHTML.getElementById('AjaxCartSubtotal');
			if ( !sectionCartForm || !sectionSubtotal ) return;
			refreshSucceeded = true;
			const cartSubtotalInnerHTML = sectionSubtotal.innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			/* Silent mode: still do the innerHTML swap so lines added/removed by
			   reconciliation (e.g. precut line appearing for the first time, JTL line
			   being added) actually render. But skip the shimmer overlay — the user
			   already saw the first shimmer from updateCartQty. A brief ~50ms flash of
			   Liquid-rendered raw prices during the swap is imperceptible compared to
			   a full second shimmer cycle. Invalidate cart cache so patcher reflects
			   the reconciled server state. */
			window.__ntCartCache = null;
			cartItems.mergeFrom(sectionCartForm);

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				var _cartno = cartItems.querySelector('[data-cart-count]')?.textContent || '0';
				elm.textContent = _cartno;
				elm.setAttribute('data-count', _cartno);
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]')?.textContent || '';
			})

			_patchSubtotalValues(cartSubtotalInnerHTML);
			if ( typeof reCalculateFreeShippingModule === 'function' ) {
				reCalculateFreeShippingModule();
			}
			if ( cartAct != 'notOpen' ) {
				if ( window.matchMedia('(max-width: 749px)').matches ) {
					if ( typeof window.showCartToast === 'function' ) window.showCartToast(addData);
				} else {
					document.querySelector('[data-js-site-cart-sidebar]').show();
				}
			}

			/* Silent mode: skip recommendation regen — the existing recs are still valid
			   for this reconciliation-only refresh, and regenerating them triggers its
			   own visible load state. */
			if ( !isSilent && document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}
			/* _saving_update intentionally NOT called here — the patcher calls it
			   after writing correct tier savings. Calling here would flash the
			   stale Liquid-rendered value. */
            if (typeof _upsell_check === 'function') {
              _upsell_check();
            }
			document.dispatchEvent(new CustomEvent('cart-updated', { bubbles: true }));
		})
		.finally(function() {
			/* On failure the patcher won't run, so clean up shimmer + height lock here.
			   On success the patcher handles cleanup for both cart-form and subtotal. */
			if (!refreshSucceeded) {
				var cf = document.getElementById('AjaxCartForm');
				if (cf) { cf.classList.remove('cart-refreshing'); cf.style.minHeight = ''; }
				_saving_update();
			}
		})
	}

}


$(function () {
  var cartWrappingForm = document.getElementById('cart-wrapping');
  /* Optimistic totals bump for the JTL toggle (Owen 2026-10-05): the fee is a
     fixed, known price (read live from the JTL card), so the displayed
     subtotal/total can move by exactly that amount at click time. The section
     swap that follows re-renders server truth over these ~1s later. */
  function __ntJtlPriceCents() {
    var el = document.querySelector('.jtl-sub--in-cart') || document.querySelector('.jtl-sub--off');
    var n = el ? parseFloat((el.textContent || '').replace(/[^0-9.]/g, '')) : NaN;
    return isNaN(n) ? 0 : Math.round(n * 100);
  }
  /* Jump the Line summary row (Justin 10-6): Subtotal leaves the fee out and
     a green "Jump the Line" row under it carries it, so the toggle adds or
     removes that row instead of bumping Subtotal. Same markup as
     snippets/cart-jtl-summary-row.liquid. */
  function __ntJtlSummaryRow(cents) {
    document.querySelectorAll('.cart__details').forEach(function (d) {
      d.querySelectorAll('.cart__jtl-row').forEach(function (r) { r.remove(); });
      var sub = d.querySelector('.cart__subtotal');
      if (!sub) return;
      if (!cents) {
        /* JTL off on a no-savings cart: Subtotal goes away now, not after the swap */
        var ms = document.getElementById('moneySaved');
        if ((parseInt(ms && ms.getAttribute('data')) || 0) <= 0) {
          sub.style.display = 'none';
          var t0 = d.querySelector('.cart__total.cart__details--row');
          if (t0) t0.classList.add('blank-row');
        }
        return;
      }
      sub.style.display = 'flex'; /* Subtotal shows with JTL even when there are no savings */
      var tot = d.querySelector('.cart__total.cart__details--row');
      if (tot) tot.classList.remove('blank-row');
      var row = document.createElement('div');
      row.className = 'cart__details--row cart__jtl-row';
      row.innerHTML = '<span class="cart__jtl-label"><svg class="cart__jtl-check" width="20" height="20" viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="10" fill="currentColor"/><path d="M6 10.2l2.7 2.7L14 7.6" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Jump the Line</span><span class="cart__jtl-value"></span>';
      row.querySelector('.cart__jtl-value').textContent = '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      sub.insertAdjacentElement('afterend', row);
    });
  }
  function __ntJtlBumpTotals(deltaCents) {
    if (!deltaCents) return;
    __ntJtlSummaryRow(deltaCents > 0 ? deltaCents : 0);
    ['#AjaxCartSubtotal .cart__total strong:last-child',
     '#MobileStickyTotal',
     '#MobileStickyCompactBtn .mobile-sticky-cart__compact-total'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (!el) return;
      var cur = parseFloat((el.textContent || '').replace(/[^0-9.]/g, ''));
      if (isNaN(cur)) return;
      var v = Math.round(cur * 100) + deltaCents;
      if (v < 0) v = 0;
      el.textContent = '$' + (v / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }

  /* Busy lock (Owen 2026-10-05): one JTL transition at a time — rapid
     clicks otherwise stack /cart calls and the optimistic DOM races the
     swaps. While busy the JTL cards gray out (.nt-jtl-busy CSS) and any
     click is reverted via preventDefault. Unlocked by the cart-updated
     the swap dispatches, with an 8s safety timeout. */
  function __ntJtlSetBusy(on) {
    window.__ntJtlBusy = !!on;
    document.querySelectorAll('.cart-wrapping').forEach(function (w) {
      w.classList.toggle('nt-jtl-busy', !!on);
    });
  }

  $(document).on("click","#cart-gift-wrapping",function(e){
    if ( window.__ntJtlBusy ) { e.preventDefault(); return; }
    var _ischecked = $(this).is(":checked");
    var __jtlUnlock = function(){ document.removeEventListener('cart-updated', __jtlUnlock); __ntJtlSetBusy(false); };
    __ntJtlSetBusy(true);
    document.addEventListener('cart-updated', __jtlUnlock);
    setTimeout(__jtlUnlock, 8000);
    if ( document.getElementById('site-cart-sidebar') ) {
      document.getElementById('site-cart-sidebar').scrollTo({top: 0, behavior: 'smooth'});
    }

    if ( _ischecked ) {
			const isVariantAvailable = $( `#cart-wrapping #add-to-cart- form [name="id"]` ).length;
			let vid = '';
			if ( isVariantAvailable == 0 ) {
				const getTempData = $( `#cart-wrapping #add-to-cart- form template` ).html();
				if ( typeof getTempData !== 'undefined' && getTempData ) {
					$( `#cart-wrapping #add-to-cart- form` ).append( getTempData );
				}
			}
			vid = $( `#cart-wrapping #add-to-cart- form [name="id"]` ).val() * 1;
			if ( typeof vid !== 'undefined' && vid ) {
				const items = [{
					id: vid,
					quantity: 1
				}];
				/* Both surfaces (Owen 2026-10-05): NO shimmer — the whole-list ghost
				   reads like a reload. Instead the fee line is inserted
				   OPTIMISTICALLY the moment the switch flips: a cached clone of the
				   real card when we have one from the SAME surface (page markup ≠
				   drawer markup), else a minimal inert placeholder built from the
				   JTL card's own text. The silent section swap replaces it with
				   server truth ~1s later. Page list = .cart-form__items; drawer
				   list = .cart__items (its items wrapped in .nt-flat-card). */
				var jtlList = document.querySelector('#AjaxCartForm .cart-form__items, #AjaxCartForm .cart__items');
				var jtlSurface = jtlList && jtlList.classList.contains('cart__items') ? 'drawer' : 'page';
				if ( jtlList && !document.querySelector('.cart-item--gift-wrapping') ) {
					var jtlGhost;
					if ( window.__ntJtlCachedLine && window.__ntJtlCachedSurface === jtlSurface ) {
						jtlGhost = window.__ntJtlCachedLine.cloneNode(true);
						jtlGhost.style.display = '';
					} else {
						jtlGhost = document.createElement('div');
						jtlGhost.className = 'cart-form-item cart-item--gift-wrapping';
						var jtlT = document.querySelector('.jtl-text');
						var jtlP = document.querySelector('.jtl-sub--in-cart') || document.querySelector('.jtl-sub--off');
						var jtlRow = document.createElement('div');
						jtlRow.className = 'cart-form-item--layout';
						jtlRow.style.cssText = 'display:flex;justify-content:space-between;align-items:center;gap:12px;';
						var jtlTitleEl = document.createElement('strong');
						jtlTitleEl.textContent = jtlT ? jtlT.textContent.trim() : 'Jump the Line';
						var jtlPriceEl = document.createElement('strong');
						jtlPriceEl.textContent = jtlP ? jtlP.textContent.replace('+','').trim() : '';
						jtlRow.append(jtlTitleEl, jtlPriceEl);
						jtlGhost.append(jtlRow);
					}
					/* inert: no live key yet — strip controls so a click can't fire
					   a /cart/change navigation against a stale or missing line */
					jtlGhost.querySelectorAll('.remove, product-quantity').forEach(function(n){ n.remove(); });
					jtlGhost.querySelectorAll('[data-js-cart-item]').forEach(function(n){ n.removeAttribute('data-js-cart-item'); n.removeAttribute('data-id'); });
					jtlGhost.removeAttribute('data-js-cart-item');
					jtlGhost.removeAttribute('data-id');
					if ( jtlSurface === 'drawer' && !jtlGhost.classList.contains('nt-flat-card') ) {
						var jtlWrap = document.createElement('div');
						jtlWrap.className = 'nt-flat-card';
						jtlWrap.append(jtlGhost);
						jtlGhost = jtlWrap;
					}
					jtlList.prepend(jtlGhost);
					__ntJtlBumpTotals(__ntJtlPriceCents());
				}
				$.post(`/cart/add.js`, {items, sections: 'helper-cart', sections_url: window.location.pathname}, function ( r ) {
					if ( typeof window.refreshCart === 'function' && document.getElementById('AjaxCartForm') ) {
						/* Both surfaces (Owen 2026-10-05): silent section-swap instead
						   of a reload / shimmering refresh — same pipeline qty changes
						   already use. The add response carries the rendered section
						   (sections param above), so the swap needs no second request
						   and replaces the optimistic line with server truth. 'notOpen'
						   never closes an already-open drawer. */
						window.refreshCart('notOpen', null, r && r.sections && r.sections['helper-cart']);
					} else {
						location.reload();
					}
				},"json").fail(function(){ location.reload(); });
			}

      // $("#cart-wrapping #product-form- [data-js-product-add-to-cart]").trigger("click");
      //cartWrappingForm.querySelector('[data-js-product-add-to-cart]').trigger("click");
    } else {
      var jtlLine = document.querySelector('.cart-item--gift-wrapping');
      if ( jtlLine && jtlLine.getAttribute('data-id') &&
           typeof window.refreshCart === 'function' && document.getElementById('AjaxCartForm') ) {
        /* Both surfaces (Owen 2026-10-05): the page's .remove control is a
           plain /cart/change?quantity=0 NAVIGATION (full reload), the
           drawer's triggers a shimmering refresh. Post the same change over
           ajax and silently section-swap instead. In the drawer the line is
           wrapped in .nt-flat-card — cache/remove the wrapper or an empty
           styled box is left behind. */
        var jtlKey = jtlLine.getAttribute('data-id');
        var jtlNode = jtlLine.closest('.nt-flat-card') || jtlLine;
        var jtlChangeUrl = (window.KROWN && KROWN.settings && KROWN.settings.routes && KROWN.settings.routes.cart_change_url) || '/cart/change.js';
        /* Optimistic: the fee line disappears the instant the switch flips —
           no whole-list shimmer (it reads like a reload). The silent swap
           below reconciles totals; the catch() reload restores truth on
           failure. Keep a clone so a re-toggle ON can repaint the real
           card instantly. REMOVE the node (not display:none): the theme
           zeroes .nt-cat-header:first-child's 26px top margin, and a
           hidden element still counts as :first-child — hiding left the
           list 26px low until the swap landed (the "catch-up" nudge). */
        window.__ntJtlCachedLine = jtlNode.cloneNode(true);
        window.__ntJtlCachedSurface = jtlNode.classList.contains('nt-flat-card') ? 'drawer' : 'page';
        jtlNode.remove();
        __ntJtlBumpTotals(-__ntJtlPriceCents());
        fetch(jtlChangeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
          body: JSON.stringify({ id: jtlKey, quantity: 0, sections: 'helper-cart', sections_url: window.location.pathname })
        }).then(function (r) {
          if (!r.ok) throw new Error('jtl remove failed ' + r.status);
          return r.json();
        }).then(function (json) {
          /* change response carries the rendered section — single round trip */
          window.refreshCart('notOpen', null, json && json.sections && json.sections['helper-cart']);
        }).catch(function () { location.reload(); });
      } else if ( jtlLine ) {
        $('.cart-item--gift-wrapping .remove').get(0).click();

        $(".cart-item--gift-wrapping .product__quantity").val(0).trigger("blur");
        //document.querySelector('.cart-item--gift-wrapping .remove').click();
      }
    }
  })

  /* ── JTL orphan sweep (Owen 2026-09-09) ────────────────────────────────
     Rush production is meaningless with nothing to rush: when the customer
     removed the last real product, the Jump the Line fee line survived
     alone, kept the toggle showing enabled, and a $19.99-fee-only cart
     could reach checkout. After any cart render (drawer refresh dispatches
     'cart-updated'; page loads covered by the timeout below), if the JTL
     fee line is the ONLY cart line left, remove it through its own remove
     control — the exact path the off-toggle uses (drawer: ajax-intercepted;
     cart page: /cart/change navigation). Self-terminating: the removal's
     own cart-updated finds no JTL line and returns. */
  function _jtlOrphanSweep() {
    var jtl = document.querySelector('.cart-item--gift-wrapping');
    if (!jtl) return;
    if (document.querySelectorAll('[data-js-cart-item]').length !== 1) return;
    var rm = jtl.querySelector('.remove');
    if (rm) rm.click();
  }
  document.addEventListener('cart-updated', _jtlOrphanSweep);
  setTimeout(_jtlOrphanSweep, 800); /* load-time pass: reload paths + landing on an already-orphaned cart */
})

/*
const cartWrappingForm = document.getElementById('cart-wrapping');
document.querySelector('[data-js-cart-wrapping-checkbox]').addEventListener('click', e=>{
  console.log(e.target.checked," ===e.target.checked")
  if ( document.getElementById('site-cart-sidebar') ) {
    document.getElementById('site-cart-sidebar').scrollTo({top: 0, behavior: 'smooth'});
  }
  if ( e.target.checked ) {
    cartWrappingForm.querySelector('[data-js-product-add-to-cart]').click();
  } else {
    if ( document.querySelector('.cart-item--gift-wrapping') ) {
      document.querySelector('.cart-item--gift-wrapping .remove').click();
    }
  }
})
*/
function _saving_update() {
  var _totalsaving = "- " + $("#moneySaved").val();
  var _savingnum = parseInt($("#moneySaved").attr("data"));
  /* Removed 500ms setTimeout wrappers — they caused a visible delay where the
     savings row showed stale data for ~1s after every qty change. The patcher
     now calls _saving_update() synchronously after computing correct savings,
     so the delay is unnecessary and was the main cause of the "flicker." */
  /* With Jump the Line in the cart, Subtotal + its JTL row show even with no savings (Justin 10-6) */
  var _hasJtl = (parseInt($(".cart__subtotal[data-jtl-cents]").first().attr("data-jtl-cents") || "0") || 0) > 0;
  if(_savingnum <= 0){
    $("#_total_saving").parents(".cart__details--row").hide();
    if (_hasJtl) {
      $(".cart__subtotal.cart__details--row").css("display","flex");
      $(".cart__total.cart__details--row").removeClass("blank-row");
    } else {
      $(".cart__subtotal.cart__details--row").hide();
      $(".cart__total.cart__details--row").addClass("blank-row");
    }
    $("#_total_saving").html(_totalsaving);
  }else{
    $("#_total_saving").parents(".cart__details--row").css("display","flex");
    $(".cart__subtotal.cart__details--row").css("display","flex");
    $(".cart__total.cart__details--row").removeClass("blank-row");
    $("#_total_saving").html(_totalsaving);
  }
  var _subEls = document.querySelectorAll('.cart-subtotal-value');
  if (_subEls.length) {
    var _cartTotal = parseInt((_subEls[0].parentElement.getAttribute('data-cart-total') || '0'));
    /* Jump the Line has its own summary row, so Subtotal leaves it out (Justin 10-6) */
    var _jtlCents = parseInt((_subEls[0].parentElement.getAttribute('data-jtl-cents') || '0')) || 0;
    var _subCents = _cartTotal + Math.max(_savingnum, 0) - _jtlCents;
    var _subFmt = '$' + (_subCents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    _subEls.forEach(function(el){ el.textContent = _subFmt; el.style.visibility = 'visible'; });
  }
  if(typeof cart__reward_func != "undefined"){
    //console.log("cart__reward_func");
    cart__reward_func();
  }
  
  if (typeof recheckcart === 'function') {
    recheckcart();
  }
  if (typeof cartStickyFunc === 'function') {
  	cartStickyFunc();
  }
  
  if (typeof cart__productblank === 'function') {
  	cart__productblank();
  }

  if (
    document.body &&
    document.body.classList.contains('template-cart') &&
    typeof window.refreshGRTUpsellBlocks === 'function'
  ) {
    try { window.refreshGRTUpsellBlocks(); } catch (e) {}
    setTimeout(function () {
      try { window.refreshGRTUpsellBlocks(); } catch (e) {}
    }, 200);
  }

  if (typeof updateCartItemCount === 'function') {
  	updateCartItemCount();
  }
  positionCartPageMobileFreeShipping();
}

function cart__productblank(){
	if($("#productblank").length > 0){
		var __productblank = $("#productblank").val() * 1;
		if(__productblank > 0){
			$(".grt__cartsection-suggetionblock").addClass("cartsection-suggetionblock");
		}else{
			$(".grt__cartsection-suggetionblock").removeClass("cartsection-suggetionblock");
		}
	}
}

_saving_update();
document.addEventListener('change', function(e) {
  if (e.target && e.target.id === 'cart-gift-wrapping') {
    setTimeout(_saving_update, 1000);
  }
});


function positionCartPageMobileFreeShipping() {
	if (
		!document.body ||
		!document.body.classList.contains('template-cart') ||
		window.innerWidth >= 768
	) {
		return;
	}

	const repositionElement = document.querySelector('.grt-cart-reposition');
	const repositionBlock = repositionElement ? repositionElement.closest('.sidebar-widget') : null;
	const lineItemContainer = document.querySelector('.grt-cart-line-item-container');
	if (!repositionBlock || !lineItemContainer || !lineItemContainer.parentNode) {
		return;
	}

	if (lineItemContainer.nextElementSibling === repositionBlock) {
		repositionBlock.style.order = '-1';
		return;
	}

	lineItemContainer.insertAdjacentElement('afterend', repositionBlock);
	repositionBlock.style.order = '-1';
}

/* ── Cart line design-note editor (Owen 2026-09-30) ─────────────────────────
   Pairs with the .nt-cart-note row rendered by arrange-properties.liquid.
   Edit/Add toggles an inline textarea; Save posts /cart/change with the
   line's FULL property set read fresh from /cart.js and only `Design Notes`
   swapped (Shopify replaces properties wholesale — a partial send would
   wipe the rest, incl. _cartImg/_Upload). hide-upload-property.js only
   rewrites /cart/add bodies, so the resend passes through untouched. After
   a successful change the canonical refreshCart('notOpen') re-renders the
   section (the swapped line gets a NEW key from Shopify, so the whole-form
   swap, not a row patch, is the correct refresh). Delegated + guarded so
   the AjaxCartForm innerHTML swaps never need re-binding. */
if (!window.__ntCartNoteInit) {
	window.__ntCartNoteInit = true;

	var __ntNoteWrap = function (el) {
		return el && el.closest ? el.closest('.nt-cart-note') : null;
	};

	document.addEventListener('click', function (e) {
		var t = e.target;
		if (!t || !t.closest) return;

		var toggle = t.closest('.nt-cart-note__toggle');
		if (toggle) {
			var w = __ntNoteWrap(toggle);
			if (!w) return;
			var ed = w.querySelector('.nt-cart-note__editor');
			var ta = w.querySelector('textarea');
			/* remember the value at open so Cancel restores it */
			ta.dataset.ntOrig = ta.value;
			w.querySelector('.nt-cart-note__view').hidden = true;
			ed.hidden = false;
			ta.focus();
			return;
		}

		var cancel = t.closest('.nt-cart-note__cancel');
		if (cancel) {
			var w2 = __ntNoteWrap(cancel);
			if (!w2) return;
			var ta2 = w2.querySelector('textarea');
			if (typeof ta2.dataset.ntOrig === 'string') ta2.value = ta2.dataset.ntOrig;
			w2.querySelector('.nt-cart-note__editor').hidden = true;
			w2.querySelector('.nt-cart-note__view').hidden = false;
			return;
		}

		var save = t.closest('.nt-cart-note__save');
		if (save) {
			var w3 = __ntNoteWrap(save);
			if (!w3 || w3.dataset.ntSaving === '1') return;
			var key = w3.getAttribute('data-nt-note-line');
			var val = w3.querySelector('textarea').value.trim();
			w3.dataset.ntSaving = '1';
			save.disabled = true;
			save.textContent = 'Saving…';

			fetch('/cart.js', { cache: 'no-store' })
				.then(function (r) { return r.json(); })
				.then(function (cart) {
					/* Multi-size groups (Owen 2026-10-07 "all notes need to be
					   unified by the parent"): the parent-card note carries
					   data-nt-note-keys = EVERY line key in the design group, and
					   one Save writes the same note to each line sequentially.
					   Single cards have only data-nt-note-line — same path, one key. */
					var lineKeys = (w3.getAttribute('data-nt-note-keys') || key || '')
						.split(',')
						.map(function (k) { return k.trim(); })
						.filter(Boolean);
					var buildProps = function (item) {
						var existing = item.properties || {};
						var props;
						if (Object.prototype.hasOwnProperty.call(existing, 'Design Notes')) {
							/* Edit: overwrite in place — key order stays exactly as stored. */
							props = Object.assign({}, existing);
							props['Design Notes'] = val;
						} else {
							/* New note: insert at the same canonical slot the add-to-cart
							   reorder (hide-upload-property.js) gives PDP-entered notes, so
							   the admin/production property order is identical either way.
							   Default + stickers: after height; spangle: after _Spangle
							   Colors; keychains (exact type, 'ninja keychain' merch never
							   has an upload prop anyway): after _Original Image. Fallback:
							   before the _discount tail, else append. */
							var keys = Object.keys(existing);
							var type = (item.product_type || '').toLowerCase();
							var idx = -1;
							if (type === 'keychains') {
								idx = Math.max(keys.indexOf('_Original Image'), keys.indexOf('Original Image'));
							} else if (type.indexOf('spangle') !== -1) {
								idx = keys.indexOf('_Spangle Colors');
							}
							if (idx === -1) idx = Math.max(keys.indexOf('_height'), keys.indexOf('height'));
							if (idx === -1) {
								var di = keys.indexOf('_discount_input');
								if (di !== -1) idx = di - 1;
							}
							props = {};
							for (var i = 0; i < keys.length; i++) {
								props[keys[i]] = existing[keys[i]];
								if (i === idx) props['Design Notes'] = val;
							}
							if (idx === -1 || idx >= keys.length) props['Design Notes'] = val;
						}
						/* RULE (Owen 2026-10-09): a Design Note wipes every reorder
						   reference — a noted line is not an exact repeat. hide-upload-
						   property.js applies it at add time; this is the notes-edited-later
						   path. Refinement (Owen, same day): a My Orders reorder carries the
						   ORIGINAL note into the cart and keeps its tag — so here only a
						   CHANGED note strips (new note, or text that differs from what the
						   line already has). Re-saving the same note keeps the tag; clearing
						   a note does not (and cannot) bring a tag back. */
						var prevNote = String(existing['Design Notes'] || '').trim();
						if (val && val !== prevNote) {
							['_reorder', 'reorder', 'design re-used', '_design re-used'].forEach(function (k) {
								if (Object.prototype.hasOwnProperty.call(props, k)) delete props[k];
							});
						}
						return props;
					};
					var changeUrl = (window.KROWN && KROWN.settings && KROWN.settings.routes && KROWN.settings.routes.cart_change_url) || '/cart/change.js';
					var found = 0;
					var chain = Promise.resolve();
					lineKeys.forEach(function (k) {
						var item = (cart.items || []).filter(function (i) { return i.key === k; })[0];
						if (!item) return; /* stale key (e.g. line removed) — skip, don't fail the rest */
						found++;
						/* A print-ready line takes no Design Notes (Justin 2026-10-28): its file is final.
						   The cart shows it no note row (snippets/nt-print-ready-line.liquid); this guards a
						   stale row, which would also have stripped the line's print-ready note. */
						if (window.ntIsPrintReadyLine && window.ntIsPrintReadyLine(item.properties)) return;
						var props = buildProps(item);
						chain = chain.then(function () {
							return fetch(changeUrl, {
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body: JSON.stringify({ id: k, quantity: item.quantity, properties: props })
							}).then(function (r) {
								if (!r.ok) throw new Error('change failed ' + r.status);
							});
						});
					});
					if (!found) throw new Error('line not found');
					return chain;
				})
				.then(function () {
					/* saved: back to the note view now (the cart merges in place, so the re-render no longer resets
					   the editor's open state or this button) */
					w3.dataset.ntSaving = '';
					save.disabled = false;
					save.textContent = 'Save';
					w3.querySelector('.nt-cart-note__editor').hidden = true;
					w3.querySelector('.nt-cart-note__view').hidden = false;
					if (typeof window.ntClampCartNotes === 'function') window.ntClampCartNotes();
					/* whole-section re-render — the edited line has a new key now */
					if (typeof window.refreshCart === 'function') {
						window.refreshCart('notOpen');
					} else {
						window.location.reload();
					}
				})
				.catch(function (err) {
					console.log('nt-cart-note save error', err && err.message);
					/* leave the editor open so nothing typed is lost */
					w3.dataset.ntSaving = '';
					save.disabled = false;
					save.textContent = 'Save';
				});
			return;
		}
	});
}

/* ── Cart note 2-line trim with inline Edit (Owen 2026-09-30) ────────────────
   The displayed note is cut so the whole view — "Note: <text>… Edit" — fits
   two lines, with Edit INLINE right after the ellipsis (a CSS line-clamp
   can't flow a trailing link into its own cut line, hence the measured
   trim). Source of truth = the editor textarea (full text, re-emitted by
   Liquid on every section render), so re-trimming is always lossless.
   Re-runs after every #AjaxCartForm innerHTML swap (MutationObserver) and
   on debounced resize. */
if (!window.__ntCartNoteClampInit) {
	window.__ntCartNoteClampInit = true;

	var ntClampCartNotes = function () {
		document.querySelectorAll('.nt-cart-note').forEach(function (wrap) {
			try {
				var view = wrap.querySelector('.nt-cart-note__view');
				var strongEl = wrap.querySelector('.nt-cart-note__text');
				var ta = wrap.querySelector('.nt-cart-note__editor textarea');
				if (!view || !strongEl || !ta || view.hidden) return;
				var full = ta.value;
				strongEl.textContent = full; /* reset before measuring */
				/* the value strong can carry a taller line-height than the label
				   (13px/1.4 vs 12px/1.4 on the by-size card) — budget on the
				   TALLER one or two real lines overshoot the cap by ~1px and the
				   trim under-fills line one. */
				var lh = Math.max(
					parseFloat(getComputedStyle(view).lineHeight) || 0,
					parseFloat(getComputedStyle(strongEl).lineHeight) || 0
				) || 18;
				var maxH = lh * 2 + 2;
				if (view.scrollHeight <= maxH) return;
				/* binary-search the largest prefix that fits with "…" */
				var lo = 0, hi = full.length;
				while (lo < hi) {
					var mid = Math.ceil((lo + hi) / 2);
					strongEl.textContent = full.slice(0, mid).replace(/\s+$/, '') + '…';
					if (view.scrollHeight <= maxH) { lo = mid; } else { hi = mid - 1; }
				}
				strongEl.textContent = full.slice(0, lo).replace(/\s+$/, '') + '…';
			} catch (e) {}
		});
	};
	window.ntClampCartNotes = ntClampCartNotes;

	var ntClampQueued = null;
	var queueClamp = function () {
		if (ntClampQueued) return;
		ntClampQueued = setTimeout(function () { ntClampQueued = null; ntClampCartNotes(); }, 60);
	};

	document.addEventListener('DOMContentLoaded', queueClamp);
	if (document.readyState !== 'loading') queueClamp();
	window.addEventListener('resize', queueClamp);
	['AjaxCartForm'].forEach(function (id) {
		var watch = function () {
			var el = document.getElementById(id);
			if (el && !el.__ntClampObserved) {
				el.__ntClampObserved = true;
				new MutationObserver(queueClamp).observe(el, { childList: true, subtree: true });
			}
		};
		watch();
		document.addEventListener('DOMContentLoaded', watch);
	});
}
